import styled from 'styled-components';

interface ItemStatusProps {
	color: string;
}

const ProposalStatus = styled('div')`
	padding-left: 4px;
	color: ${(props: ItemStatusProps) => props.color};
	display: inline-block;
`;

export { ProposalStatus };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ListItem/ProposalStatus/styles.ts